import React, { useState, useEffect } from "react";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasConsent = localStorage.getItem("cookieConsent");
    if (!hasConsent) {
      setShowConsent(true);
    }
    
    // Set initial desktop state
    if (typeof window !== 'undefined') {
      setIsDesktop(window.innerWidth > 768);
      
      // Add resize listener
      const handleResize = () => {
        setIsDesktop(window.innerWidth > 768);
      };
      
      window.addEventListener('resize', handleResize);
      
      // Clean up
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowConsent(false);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        maxWidth: isDesktop ? "500px" : "90%",
        width: isDesktop ? "500px" : "90%",
        backgroundColor: "rgba(31, 31, 31, 0.95)", // #1f1f1f with transparency
        color: "white",
        padding: "0.7rem 1rem",
        zIndex: 9999,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.2)",
        fontSize: "0.8rem",
        borderRadius: "8px",
      }}
    >
      <div style={{ maxWidth: "85%" }}>
        This website uses cookies to ensure you get the best experience.{" "}
        <a 
          href="/privacy-policy" 
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2eb488", textDecoration: "none" }}
        >
          Learn more
        </a>
      </div>
      <button
        onClick={acceptCookies}
        style={{
          backgroundColor: "#2eb488", // Green color
          color: "white",
          border: "none",
          padding: "0.4rem 0.8rem",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "normal",
          fontSize: "0.8rem",
        }}
      >
        Accept
      </button>
    </div>
  );
};

export default CookieConsent; 